/**
 * Module: Analytics
 * Staff Level GA4 & Ads Integration
 */

export const init = () => {
    const config = document.body.dataset;
    const gtagId = config.gtagId;
    
    if (!gtagId || window.AnalyticsInitialized) return;
    
    // Inyectar script de Google
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    window.gtag = gtag; // Única excepción permitida para interoperabilidad con Google
    
    // Consent Mode v2: Default State (Compliance First)
    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500
    });

    gtag('js', new Date());
    gtag('config', gtagId, {
        'anonymize_ip': true,
        'cookie_flags': 'SameSite=None;Secure'
    });

    // RUM: Core Web Vitals Tracking
    import('https://unpkg.com/web-vitals@4/dist/web-vitals.js?module').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
        function sendToGoogleAnalytics({ name, delta, id }) {
            gtag('event', name, {
                event_category: 'Web Vitals',
                event_label: id,
                value: Math.round(name === 'CLS' ? delta * 1000 : delta),
                non_interaction: true,
            });
        }
        onCLS(sendToGoogleAnalytics);
        onINP(sendToGoogleAnalytics);
        onLCP(sendToGoogleAnalytics);
        onFCP(sendToGoogleAnalytics);
        onTTFB(sendToGoogleAnalytics);
    }).catch(err => console.error('Failed to load web-vitals', err));

    // Rastreo de Scroll
    let scrollMarkers = [25, 50, 75, 90];
    let trackedMarkers = [];
    window.addEventListener('scroll', () => {
        let scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
        scrollMarkers.forEach(marker => {
            if (scrollPercent >= marker && !trackedMarkers.includes(marker)) {
                trackedMarkers.push(marker);
                trackEvent('scroll_depth', { 'depth': marker + '%' });
            }
        });
    }, { passive: true });

    // Delegación de clics global (Agnostic Lead Tracking)
    document.addEventListener('click', (e) => {
        const target = e.target.closest('a, button, [data-lead-type], [data-analytics-event]');
        if (!target) return;

        const href = target.getAttribute('href') || '';
        const leadType = target.dataset.leadType;
        const leadLabel = target.dataset.leadLabel || target.innerText?.trim() || 'unlabeled';
        const analyticsEvent = target.dataset.analyticsEvent;

        // 1. Eventos de UI / Interacción
        if (analyticsEvent) {
            trackEvent(analyticsEvent, { 
                'component_label': target.dataset.analyticsLabel || leadLabel 
            });
        }

        // 2. Prioridad: data-lead-type explícito
        if (leadType) {
            trackLead(leadType, leadLabel);
        } 
        // 3. Fallback: Detección automática por protocolo
        else if (href.startsWith('tel:')) {
            trackLead('Phone', href.replace('tel:', ''));
        } 
        else if (href.startsWith('mailto:')) {
            trackLead('Email', href.replace('mailto:', ''));
        }
    });

    // Tracking de carga de mapas (Map Interactivity)
    document.body.addEventListener('map_loaded', (e) => {
        trackEvent('map_view', { 'location_name': e.detail.title || 'unknown' });
    });

    window.AnalyticsInitialized = true;
    console.debug('📊 [Analytics] Staff Engine initialized (Event Delegation Active).');

    // Auto-track conversions on Thank You page (Legacy Fallback)
    if (window.location.pathname.includes('/gracias/')) {
        trackConversion();
    }
};

export const trackEvent = (eventName, params = {}) => {
    if (window.gtag) {
        window.gtag('event', eventName, params);
        console.debug(`[Analytics] Event: ${eventName}`, params);
    }
};

export const trackLead = (method, label) => {
    trackEvent('generate_lead', {
        'method': method,
        'event_label': label,
        'value': 1.0,
        'currency': 'USD'
    });
};

/**
 * Enterprise Conversion Tracking (Google Ads / GA4)
 * Can be called manually for AJAX forms or automatically on /gracias/
 */
export const trackConversion = () => {
    const config = document.body.dataset;
    const ec_email = sessionStorage.getItem('ec_email');
    const ec_phone = sessionStorage.getItem('ec_phone');
    
    if (window.gtag) {
        if (ec_email || ec_phone) {
            window.gtag('set', 'user_data', { "email": ec_email, "phone_number": ec_phone });
        }

        if (config.conversionId) {
            window.gtag('event', 'conversion', {
                'send_to': config.conversionId,
                'value': 1.0,
                'currency': 'PEN'
            });
        }
    }

    sessionStorage.removeItem('ec_email');
    sessionStorage.removeItem('ec_phone');
};


